import React, {useState, useRef, useEffect,} from "react";
import styles from './PartnerWallet.module.css';
import { useNavigate, useParams } from "react-router-dom";
import PartnerNavSlider from '../NavSlider/PartnerNavSlider';
import SplashScreen from "../../SplashScreen";

export default function PartnerWallet() {
  const navigate = useNavigate();

  const { userId, deviceUuid } = useParams();
  const [activeNav, setActiveNav] = useState("clipboard");

  const basePath =
    userId && deviceUuid
      ? `/${userId}/${deviceUuid}`
      : "";

  const handleNavigation = (tab, path) => {
    setActiveNav(tab);

    if (basePath) {
      navigate(`${basePath}${path}`);
    } else {
      navigate(path);
    }
  };

  const [activeTab, setActiveTab] = useState('wallet');
  const [searchTerm, setSearchTerm] = useState('');

  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenu = () => {
    setMenuOpen(true);
  };

  const transactions = [
    {
      id: 1,
      name: 'Ridhwan Nordin',
      date: 'June 6, 2023 at 3:36 PM',
      amount: '+ ₹1,800',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150'
    },
    {
      id: 2,
      name: 'Ridhwan Nordin',
      date: 'June 6, 2023 at 3:36 PM',
      amount: '+ ₹1,800',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150'
    },
    {
      id: 3,
      name: 'Ridhwan Nordin',
      date: 'June 6, 2023 at 3:36 PM',
      amount: '+ ₹1,800',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150'
    },
    {
      id: 4,
      name: 'Ridhwan Nordin',
      date: 'June 6, 2023 at 3:36 PM',
      amount: '+ ₹1,800',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150'
    },
    {
      id: 5,
      name: 'Ridhwan Nordin',
      date: 'June 6, 2023 at 3:36 PM',
      amount: '+ ₹1,800',
      avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150'
    }
  ];

  const filteredTransactions = transactions.filter(t =>
    t.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

        const [user, setUser] = useState(null);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState("");
      
        
        const API_URLA =
          "https://coinyoco.world/brobizee-api/get_user.php";
      
       
        const userIdA =
          localStorage.getItem("user_id");
      
      
      
        useEffect(() => {
      
          const fetchUserData = async () => {
      
            try {
      
              setLoading(true);
              setError("");
      
      
              if (!userIdA) {
      
                setError(
                  "User ID not found in localStorage"
                );
      
                setLoading(false);
      
                return;
              }
      
      
              console.log(
                "Fetching user:",
                userIdA
              );
      
      
           
              const response = await fetch(
                `${API_URLA}?user_id=${encodeURIComponent(userIdA)}`
              );
      
      
         
              const responseText =
                await response.text();
      
      
              console.log(
                "RAW GET USER RESPONSE:",
                responseText
              );
      
      
              if (!response.ok) {
      
                throw new Error(
                  `HTTP ${response.status}: ${responseText}`
                );
              }
      
      
              let data;
      
              try {
      
                data =
                  JSON.parse(responseText);
      
              } catch (jsonError) {
      
                console.error(
                  "Invalid JSON:",
                  responseText
                );
      
                throw new Error(
                  "PHP API returned invalid JSON"
                );
              }
      
      
              console.log(
                "GET USER RESULT:",
                data
              );
      
      
           
              if (data.success) {
      
                setUser(data.user);
      
              } else {
      
                setError(
                  data.message ||
                  "Unable to fetch user data"
                );
              }
      
            } catch (error) {
      
              console.error(
                "Fetch user error:",
                error
              );
      
              setError(
                error.message ||
                "Something went wrong while loading user data"
              );
      
            } finally {
      
              setLoading(false);
      
            }
      
          };
      
      
          fetchUserData();
      
        }, [userIdA]);
      
      
        // =====================================================
        // LOADING
        // =====================================================
      
        if (loading) {
      
          return (
      
            <div className="show-data-page">
      
              <div className="show-data-card">
      
                <h2>
                              {/* <SplashScreen /> */}
                  {/* Loading user data... */}
                </h2>
      
              </div>
      
            </div>
      
          );
      
        }
      
      
        // =====================================================
        // ERROR
        // =====================================================
      
        if (error) {
      
          return (
      
            <div className="show-data-page">
      
              <div className="show-data-card">
      
                <h2>
                  Error
                </h2>
      
                <p>
                  {error}
                </p>
      
                <button
                  type="button"
                  onClick={() =>
                    window.location.reload()
                  }
                >
                  Retry
                </button>
      
              </div>
      
            </div>
      
          );
      
        }
      
      
        // =====================================================
        // NO USER
        // =====================================================
      
        if (!user) {
      
          return (
      
            <div className="show-data-page">
      
              <div className="show-data-card">
      
                <h2>
                  No user data found
                </h2>
      
              </div>
      
            </div>
      
          );
      
        }

  return (
    <div className={styles.screenWrapper}>

      {/* =====================================================
                                NAV SLIDER
                            ====================================================== */}

      <PartnerNavSlider
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        navigate={navigate}
      />

      <div className={styles.deviceFrame}>

        {/* Fixed Header */}
        <header className={styles.appBar}>
          {/* <button type="button" className={styles.backBtn} aria-label="Go Back">
            <svg width="22" height="16" viewBox="0 0 24 16" fill="none" stroke="#005CA9" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 8H5" />
              <polyline points="12 1 5 8 12 15" />
            </svg>
          </button> */}

          <h1 className={styles.headerTitle}>My Account</h1>

          <button type="button" className={styles.menuBtn} aria-label="Menu" onClick={handleMenu} >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#005CA9" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </header>

        {/* Scrollable Container */}
        <div className={styles.scrollContainer}>

          {/* User Profile Card */}
          <section className={styles.profileSection}>
            
             <img
              src={user.profile_url}
              alt={user.name || "Profile"}
             className={styles.avatarImg}
              onError={(e) => {

                e.currentTarget.style.display =
                  "none";

              }}
            />
            <div className={styles.userInfo}>
              <span className={styles.phoneNo}>{user.mobile_number || "-"}</span>
              <span className={styles.upiId}>Akashplumber52222@okaxis</span>
            </div>
            <div className={styles.qrBadge}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8">
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="3" height="3" />
                <rect x="18" y="18" width="3" height="3" />
                <rect x="14" y="18" width="3" height="3" />
                <rect x="18" y="14" width="3" height="3" />
              </svg>
            </div>
          </section>

          {/* Linked Bank Card */}
          <section className={styles.bankCard}>
            <div className={styles.bankIconCircle}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#005CA9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="21" x2="21" y2="21" />
                <line x1="6" y1="18" x2="6" y2="11" />
                <line x1="10" y1="18" x2="10" y2="11" />
                <line x1="14" y1="18" x2="14" y2="11" />
                <line x1="18" y1="18" x2="18" y2="11" />
                <polygon points="12 3 2 9 22 9 12 3" />
              </svg>
            </div>
            <span className={styles.bankName}>ICICI Bank . xxxx 4411</span>
          </section>

          <div className={styles.changeBankLabel}>CHANGE MY BANK ACCOUNT</div>

          <section className={styles.balanceBanner}>
            <div className={styles.balanceTitleGroup}>
              <span className={styles.yourBalanceText}>YOUR BALANCE</span>
            </div>
            <div className={styles.balanceAmountGroup}>
              <span className={styles.amount}>₹ 500</span>
              <div className={styles.walletIcon}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#005CA9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" />
                  <path d="M4 6v12a2 2 0 0 0 2 2h14v-4" />
                  <rect x="14" y="12" width="6" height="4" rx="1" />
                </svg>
              </div>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#005CA9" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </section>

          {/* Action Row */}
          <section className={styles.actionRow}>
            <button type="button" className={styles.addMoneyBtn}>
              Add money
            </button>
            <button type="button" className={styles.investBtn}>
              <span>INVEST</span>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FF6B00" strokeWidth="2.2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a10 10 0 0 1 10 10h-10V2z" />
              </svg>
            </button>
          </section>

          {/* Metrics Summary */}
          <section className={styles.statsContainer}>
            <div className={styles.statRow}>
              <div className={styles.statLeft}>
                <div className={styles.statIconCircle}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#005CA9" strokeWidth="2">
                    <line x1="3" y1="21" x2="21" y2="21" />
                    <line x1="6" y1="18" x2="6" y2="11" />
                    <line x1="10" y1="18" x2="10" y2="11" />
                    <line x1="14" y1="18" x2="14" y2="11" />
                    <line x1="18" y1="18" x2="18" y2="11" />
                    <polygon points="12 3 2 9 22 9 12 3" />
                  </svg>
                </div>
                <span className={styles.statTitle}>TODAY BANK TRANSFER</span>
              </div>
              <span className={styles.statVal}>2000 Rs.</span>
            </div>

            <div className={styles.statRow}>
              <div className={styles.statLeft}>
                <div className={styles.statIconCircle}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#005CA9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17" />
                    <path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.8a2 2 0 0 0-2.8-2.8l-2.8 2.8" />
                    <circle cx="16" cy="6" r="3" />
                  </svg>
                </div>
                <span className={styles.statTitle}>TODAY EARNING</span>
              </div>
              <span className={styles.statVal}>184 Rs.</span>
            </div>
          </section>

        </div>

        {/* =====================================================
    BOTTOM NAVIGATION
====================================================== */}

        {/* =================================================
            BOTTOM NAVIGATION
        ================================================= */}

                <div className={styles.bottomNavWrapper}>

                    <nav
                        className={styles.bottomNav}
                        aria-label="Bottom Navigation"
                    >

                        {/* =============================================
                               HOME
                                 ============================================= */}

                        <button
                            type="button"
                            className={`${styles.navBtn} ${activeNav === "home"
                                    ? styles.active
                                    : ""
                                }`}
                            onClick={() =>
                                handleNavigation(
                                    "home",
                                    "/partnerhome"
                                )
                            }
                            aria-label="Home"
                        >

                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >

                                <path
                                    d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9"
                                />

                                <polyline
                                    points="9 22 9 12 15 12 15 22"
                                />

                            </svg>

                            <span className={styles.navLabel}>
                                Home
                            </span>

                        </button>


                        {/* =============================================
                              T ASKS
                             ============================================= */}

                        <button
                            type="button"
                            className={`${styles.navBtn} ${activeNav === "book"
                                    ? styles.active
                                    : ""
                                }`}
                            onClick={() =>
                                handleNavigation(
                                    "book",
                                    "/partner_booking"
                                )
                            }
                            aria-label="Tasks"
                        >

                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >

                                <path
                                    d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                                />

                                <rect
                                    x="8"
                                    y="2"
                                    width="8"
                                    height="4"
                                    rx="1"
                                />

                                <path d="M8 11h8" />

                                <path d="M8 15h5" />

                            </svg>

                            <span className={styles.navLabel}>
                                Tasks
                            </span>

                        </button>


                        {/* =============================================
                              WALLET
                          ============================================= */}

                        <button
                            type="button"
                            className={`${styles.navBtn} ${activeNav === "clipboard"
                                    ? styles.active
                                    : ""
                                }`}
                            onClick={() =>
                                handleNavigation(
                                    "clipboard",
                                    "/partner_wallet"
                                )
                            }
                            aria-label="Wallet"
                        >

                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >

                                <rect
                                    x="2"
                                    y="6"
                                    width="20"
                                    height="12"
                                    rx="3"
                                />

                                <path d="M18 12h.01" />

                            </svg>

                            <span className={styles.navLabel}>
                                Wallet
                            </span>

                        </button>

                    </nav>

                </div>

      </div>
    </div>
  );
}